module.exports = __webpack_public_path__ + "img/10no-five.d9de057d.jpg";